import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "couponList" };
const _hoisted_2 = {
    key: 0,
    class: "text-center my-4"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "sr-only" }, "Deine Gutscheine werden geladen ...", -1);
const _hoisted_5 = [
    _hoisted_3,
    _hoisted_4
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_coupon_card = _resolveComponent("coupon-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
            : _createCommentVNode("", true),
        (!_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.coupons, (coupon) => {
                return (_openBlock(), _createBlock(_component_coupon_card, {
                    coupon: coupon,
                    "current-selected-coupon-code": _ctx.currentSelectedCouponCode,
                    key: `coupon-popup-card-${coupon.code}`,
                    onApplyCoupon: _ctx.applyCoupon
                }, null, 8, ["coupon", "current-selected-coupon-code", "onApplyCoupon"]));
            }), 128))
            : _createCommentVNode("", true)
    ]));
}
